export const languageFlags = {
  ar: "🇸🇦",  // Arabic → Saudi Arabia
  bn: "🇧🇩",  // Bengali → Bangladesh
  zh: "🇨🇳",  // Chinese → China
  cs: "🇨🇿",  // Czech → Czech Republic
  da: "🇩🇰",  // Danish → Denmark
  nl: "🇳🇱",  // Dutch → Netherlands
  en: "🇬🇧",  // English → UK (or "🇺🇸" for US)
  et: "🇪🇪",  // Estonian
  fi: "🇫🇮",  // Finnish
  fr: "🇫🇷",  // French
  de: "🇩🇪",  // German
  el: "🇬🇷",  // Greek
  he: "🇮🇱",  // Hebrew
  hi: "🇮🇳",  // Hindi
  hu: "🇭🇺",  // Hungarian
  id: "🇮🇩",  // Indonesian
  it: "🇮🇹",  // Italian
  ja: "🇯🇵",  // Japanese
  ko: "🇰🇷",  // Korean
  lv: "🇱🇻",  // Latvian
  lt: "🇱🇹",  // Lithuanian
  ms: "🇲🇾",  // Malay
  no: "🇳🇴",  // Norwegian
  fa: "🇮🇷",  // Persian
  pl: "🇵🇱",  // Polish
  pt: "🇵🇹",  // Portuguese
  ro: "🇷🇴",  // Romanian
  ru: "🇷🇺",  // Russian
  sk: "🇸🇰",  // Slovak
  sl: "🇸🇮",  // Slovenian
  es: "🇪🇸",  // Spanish
  sv: "🇸🇪",  // Swedish
  ta: "🇮🇳",  // Tamil → India
  th: "🇹🇭",  // Thai
  tr: "🇹🇷",  // Turkish
  uk: "🇺🇦",  // Ukrainian
  ur: "🇵🇰",  // Urdu
  vi: "🇻🇳",  // Vietnamese
  cy: "🏴",  // Welsh
};

export const fallback = '🏳️'